module.exports = __webpack_public_path__ + "06e87d404276a11c64de661da86cc0b6.svg";


//////////////////
// WEBPACK FOOTER
// ./components/icon/svg/close.svg
// module id = xofd
// module chunks = 0